import { EMPTY_ARRAY, IApplicationState, TListId } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IPushNotificationsHOCProps } from './types';
import { PushNotifications } from '../../components/PushNotifications/PushNotifications';
import { IPushNotificationsEvents, IPushNotificationsFields } from '../../components/PushNotifications/types';
import {
    EPushNotificationSettingsScope,
    EPushNotificationSettingsTypes,
    EPushNotificationSubscribeCases
} from '../../../../../../../../types/rest/IRestPushNotificationSettings';
import { getPushNotificationSettingsByBoardId } from '../../../../../../../../store/model/selectors/getPushNotificationSettingsByBoardId';
import { getPanelReadonly } from '../../../../selectors/getPanelReadonly';
import { onChange } from './events/onChange';
import { onNotifySubscribeCaseClick } from './events/onNotifySubscribeCaseClick';
import { onNotifyTypeClick } from './events/onNotifyTypeClick';
import { onMoveToListToggle } from './events/onMoveToListToggle';
import { getListMoveToSelectOptionsSelector } from './selectors/getListMoveToSelectOptions';
import { onListChangeToToggle } from './events/onListChangeToToggle';
import { getListChangeToSelectOptionsSelector } from './selectors/getListChangeToSelectOptions';
import { onOpenSettings } from './events/onOpenSettings';
import { onScopeClick } from './events/onScopeClick';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';
import { isKanbanchiUser } from '../../../../../../../../store/model/authUser/selectors/isKanbanchiUser';

const mapStateToProps = () => {
    const getSearchSelectListMoveToOptions = getListMoveToSelectOptionsSelector();
    const getSearchSelectListChangeToOptions = getListChangeToSelectOptionsSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        ownProps: IPushNotificationsHOCProps
    ): IPushNotificationsFields => {
        const { boardId } = ownProps;
        const pushNotification = getPushNotificationSettingsByBoardId(state, boardId);
        const isReadonly = getPanelReadonly(state, boardId);
        return {
            isEnabled: pushNotification && pushNotification.enabled,
            isKanbanchiUser: isKanbanchiUser(state),
            isReadonly,
            listChangeToOptions: getSearchSelectListChangeToOptions(state, boardId),
            listMoveToOptions: getSearchSelectListMoveToOptions(state, boardId),
            scopes: pushNotification && pushNotification.scope ? pushNotification.scope : EMPTY_ARRAY,
            subscribeCases: pushNotification && pushNotification.subscribeCases ? pushNotification.subscribeCases : EMPTY_ARRAY,
            types: pushNotification && pushNotification.types ? pushNotification.types : EMPTY_ARRAY,
        }
    };
    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IPushNotificationsHOCProps
): IPushNotificationsEvents => {
    const { boardId } = ownProps;
    return {
        onChange: (scopes: EPushNotificationSettingsScope[],
            subscribeCases: EPushNotificationSubscribeCases[],
            types: EPushNotificationSettingsTypes[]) => dispatch(onChange(boardId, scopes, subscribeCases, types)),
        onListChangeToToggle: (listId: TListId) => dispatch(onListChangeToToggle(boardId, listId)),
        onListMoveToToggle: (listId: TListId) => dispatch(onMoveToListToggle(boardId, listId)),
        onNotifySubscribeCaseClick: (scope: EPushNotificationSubscribeCases, checked: boolean) => dispatch(onNotifySubscribeCaseClick(scope, checked)),
        onNotifyTypeClick: (scope: EPushNotificationSettingsTypes, checked: boolean) => dispatch(onNotifyTypeClick(scope, checked)),
        onOpenSettings: () => dispatch(onOpenSettings()),
        onScopeClick: (scope: EPushNotificationSettingsScope, checked: boolean) => dispatch(onScopeClick(scope, checked)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    }
};

export const PushNotificationsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(PushNotifications);

PushNotificationsHOC.displayName = 'PushNotificationsHOC';
